import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { motion } from "framer-motion";
import { useState } from "react";
import { toast } from "sonner";

import { HeroCanvas } from "@/components/motion/HeroCanvas";
import { Button } from "@/components/ui/Button";
import { isAuthenticated, loginWithGoogle } from "@/lib/pb";

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    if (isAuthenticated()) throw redirect({ to: "/" });
  },
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    setLoading(true);
    try {
      await loginWithGoogle();
      navigate({ to: "/" });
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Login failed");
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen bg-bg text-text overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <HeroCanvas />
      </div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-bg/40 via-bg/70 to-bg" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6"
      >
        <p className="path-chip mb-3">/console/login</p>
        <h1 className="text-5xl md:text-6xl font-semibold tracking-tight text-balance text-center">
          Thinkler <span className="text-primary">Console</span>
        </h1>
        <p className="text-muted mt-4 text-center max-w-md">
          SEO command center. Aprobaciones, analytics y agentes autónomos en un solo lugar.
        </p>

        <Button onClick={handleLogin} disabled={loading} className="mt-10">
          {loading ? "conectando..." : "Ingresar con Google"}
        </Button>

        <div className="mt-16 flex items-center gap-2 text-xs text-muted font-mono">
          <span className="inline-block w-2 h-2 rounded-full bg-success animate-pulse-led" />
          system operational
        </div>
      </motion.div>
    </div>
  );
}
